import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function GuestRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <i className="ri-loader-4-line animate-spin text-xl text-foreground-500" />
      </div>
    );
  }

  if (user) return <Navigate to="/sites" replace />;
  return <Outlet />;
}
